

























import {Component, Prop, Vue} from 'vue-property-decorator';
import Toast from '@/shared/services/toast';

@Component({
	components: {}
})
export default class ReadonlyCopyableField extends Vue {
	@Prop() public readonlyValue: string;
	@Prop() public onCopyMessage: string;


	public onCopiedToClipboard() {
		Toast.showInfo(this.onCopyMessage);
	}
}
